const localTokenColors = {
  Bnb: '#fff',
  Hord: '#8D6752',
};

export const generateColor = (str) => {
  const localValue = localTokenColors?.[str];
  if (localValue) return localValue;
  if (!str) return;

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += `00${value.toString(16)}`.substr(-2);
  }
  return colour;
};
